<template>
<div>
    <modal v-model="modal" :title="title" dir="right" :modalClass="['fill', 'md right h100']" hideActions>

    <vertical-content v-if="transactions && transactions.length > 0" @OnBottom="LoadTransactionsChunk()">
        <div class="section">
            <div class="" >
                    <div class="entry selectable" 
                    v-for="(transaction, index) in transactions"
                    :key="index"
                    @click="$refs.expenseDetails.Open(transaction)">
                        <div class="flex fill align-center">
                            <avatar class="mr10"
                            defaultImageIcon="1727"
                            :imageIcon="transaction.type">
                            </avatar>
                            <div class="flex-fill flex column">
                                <div class="bold">{{transaction.type}}</div>
                                <div class="secondary-text" v-if="transaction.comment"><span class="bold">Comentario:</span> {{transaction.comment}}</div>
                                <div class="secondary-text" v-if="transaction.custom_data && transaction.custom_data.created_by"><span class="bold">Ingresado por:</span> {{transaction.custom_data.created_by}}</div>
                                <div class="secondary-text"><span class="bold">Fecha:</span> {{Util.Date(transaction.date, 'DD/MM/YYYY HH:mm')}}</div>
                                <div class="secondary-text cred" v-if="transaction.deleted_at"><span class="bold">Eliminado:</span> {{Util.Date(transaction.deleted_at, 'DD/MM/YYYY HH:mm')}} por {{transaction.custom_data.deleted_by}}</div>
                                <div class="secondary-text cyellow" v-if="!transaction.expense_turn" title="No se muestra en reportes de Turno"><span class="bold"><i class="icon icon-circle-exclamation mr5"></i> No contabilizado en turno</span></div>
                            </div>
                            <div class="flex column ta-right unshrink">
                                <div :class="transaction.deleted_at ? 'line-through' : 'bold'">{{Util.Price(transaction.money)}}</div>
                                <div class="secondary-text">{{Util.PayMethod(transaction.pay_method)}}</div>
                            </div>
                        </div>
                    </div>
                </div>

        </div>
        <div class="secondary-text ta-center mt10" v-if="!transactions.length">No hay transacciones.</div>
    </vertical-content>

  
    </modal>
    <expense-details ref="expenseDetails" @OnTransactionDeleted="TransactionDeleted($event.id)"></expense-details>
</div>
</template>

<script>
export default {
    props: {
        chunkSize: {
            type: Number,
            default: 20,
        },
        view : {
            type : String,
            default : null
        }
    },
    data() {
        return {
            list: [], //ids arrays
            transactions: [], //transactions data
            title: 'Transacciones',
            modal: false,
            statsDetails: null,
            transactionsId: [],
            tab: null,
            tabs: null,
            saleType: {
                TAKEAWAY: 'Llevar',
                SERVE: 'Servir',
                DELIVERY: 'Delivery'
            },
            mediums: {
                INFLUYE_ADMIN: 'Punto de Venta',
                INFLUYE_APP: 'Influye App',
                INFLUYE_WEB: 'Ecommerce'
            },
            dict: {
                sections: 'Secciones',
                items: 'Items',
                group_modifiers: 'Grupo Modificadores',
                modifiers: 'Modificadores',
            },
            days: {
                0: 'Domingo',
                1: 'Lunes',
                2: 'Martes',
                3: 'Miércoles',
                4: 'Jueves',
                5: 'Viernes',
                6: 'Sábado'
            },
            statsConfig: null,
            dynamicContextModal: {},
            dynamicIndex: {},
            initPrevData: null,
            scale: [],
            fromTitle: null,
            customersWithNumberTransactions: [],
            listTransactionCustomers: []
        }
    },
    methods: {
        Open(transactionList, newTitle, params, fromTitle, extraTabs = [] ) {
            this.customersWithNumberTransactions = [];
            this.tabs = ['Transacciones', ...extraTabs];
            this.scale = ['sections', 'items', 'group_modifiers', 'modifiers'];
            this.dynamicContextModal = { sections: null, items: null, group_modifiers: null, modifiers: null };
            this.statsDetails = null;
            this.dynamicIndex = {
                ind_sections: 0,
                ind_items: 0,
                ind_group_modifiers: 0,
                ind_modifiers: 0
            };
            this.initPrevData = null;
            
            if(params && params.stats){
                this.scale.forEach(element => {
                    if (params[element] === false) {
                        this.scale = this.scale.filter(item => item !== element);
                    }

                    this.fromTitle = fromTitle;
                    if(params[`prev_${element}`]) this.initPrevData = {level: element, data: params[`prev_${element}`]};
                });

                Object.keys(this.dynamicContextModal).forEach(element => {
                    if (params[element] === false) {
                        delete this.dynamicContextModal[element];
                    }
                });

                this.tabs.unshift('Estadísticas');
                this.$nextTick(() => {this.GetDeliveryStatisticsDetails()});
                this.statsConfig = params;
                if(transactionList.length > 0) this.transactionsId = transactionList;
            }

            this.title = newTitle ? newTitle : 'Transacciones';

            this.transactions = [];
            this.list = [];
            
            if(transactionList.length > 0)
            {
                if(typeof transactionList[0] == 'number')
                {
                    //Lista de IDs
                    this.list = JSON.parse(JSON.stringify(transactionList));
                    if(this.tabs.length == 1) this.LoadTransactionsChunk();
                }
                else
                {
                    //Lista de Transacciones (data)
                    this.transactions = transactionList;
                    //TODO: extract transactions ids?
                }
            }
            
            this.listTransactionCustomers = this.Util.Copy(this.list);
            this.modal = true;

            //if(newTabs && newTabs.includes("Estadísticas")) this.GetDeliveryStatisticsDetails();
        },
        Close() {
            this.modal = false;
            this.statsDetails = null;
            this.list = [];
            this.tabs = null;
            this.transactions = [];
            this.listTransactionCustomers = [];
            this.$refs.details.Close();
        },
        LoadTransactionsChunk()
        {
            if(this.list.length == 0) return;
            this.Loading();
            axios.post(`/expenses/${this.Local.id}/list`, {ids: this.list.splice(0, this.chunkSize)}).then(res => {
                this.transactions = this.transactions.concat(res.data);
                this.Response(res);
                this.modal = true;
            }).catch(err => {
                this.Response(err);
            });
        },
        TransactionDeleted(id) {
            for(var i = 0; i < this.transactions.length; i++)
            {
                if(this.transactions[i].id == id)
                {
                    this.transactions.splice(i, 1);
                    break;
                }
            }
            this.$emit('OnTransactionDeleted', id);
        },
        TransactionEdit(transaction) {
            this.$emit('OnTransactionEdit');
            for(var i = 0; i < this.transactions.length; i++)
            {
                if(this.transactions[i].id == transaction.id)
                {
                    this.$set(this.transactions, i, transaction)
                    return;
                }
            }
        },
        DeliveryCost(transaction)
        {
            for(var i = transaction.orders.length-1; i >= 0; i--)
            {
                var order = transaction.orders[i];
                if(order.type == 'DELIVERY')
                {
                    return `<i class="icon icon-${order.external ? 'cargo' : 'delivery'} mr5"></i>` + this.Util.Price(order.total_money);
                }
            }
            return '';
        },
    },
    computed: {
        sales() {
            return this.filterAndCalculate(this.statsDetails.sales, this.fromTitle, this.statsConfig.label);
        },
        mediumsSection() {
            return this.filterAndCalculate(this.statsDetails.mediums, this.fromTitle, this.statsConfig.label);
        },
        payMethods() {
            return this.filterAndCalculate(this.statsDetails.pay_methods, this.fromTitle, this.statsConfig.label);
        },
        daysSection() {
            return this.filterAndCalculate(this.statsDetails.days, this.fromTitle, this.statsConfig.label);
        },
        hours() {
            return this.filterAndCalculate(this.statsDetails.hours, this.fromTitle, this.statsConfig.label);
        }
    },
}                               
</script>
<style lang="scss">
.scroll-modal-container {
    max-height: 250px;
    overflow-y: auto;
    padding: 10px;
    margin: -10px !important;
}

@media (max-width: 820px) {
    .scroll-modal-container {
        padding: 0px;
        margin: 0px;
        height: auto;
    }
}
</style>